import type { FeatureCollection, GeoJsonObject } from "geojson";
import type { LatLngBoundsExpression, LatLngExpression } from "leaflet";
import {
  atlantaBoundary,
  fairburnBoundary,
} from "../../../components/customs/map/fairburnBoundary";

export interface OrganizationMapConfig {
  boundary?: GeoJsonObject;
  center: LatLngExpression;
  maxBounds: LatLngBoundsExpression;
  zoom: number;
}

const fairburnMapConfig: OrganizationMapConfig = {
  boundary: fairburnBoundary,
  center: [33.547773917135956, -84.58355386796885],
  maxBounds: [
    [33.5025097942569, -84.6317954471098],
    [33.593038040015, -84.5353122888279],
  ],
  zoom: 12,
};

const atlantaMapConfig: OrganizationMapConfig = {
  boundary: atlantaBoundary,
  center: [43.1754825002253, -79.24950637516645],
  maxBounds: [
    [43.1060812653761, -79.3209328003851],
    [43.2448837350745, -79.1780799499478],
  ],
  zoom: 12,
};

const organizationMapConfigs: Readonly<Record<string, OrganizationMapConfig>> = {
  "7adc585d-5b70-48bb-9aff-a644b38b9894": fairburnMapConfig,
  "25594f98-3ac4-4d9b-926a-6f3256b868fc": atlantaMapConfig,
};

export const DEFAULT_ORGANIZATION_MAP_CONFIG = fairburnMapConfig;

export const getOrganizationMapConfig = (organizationId?: string): OrganizationMapConfig =>
  organizationId
    ? (organizationMapConfigs[organizationId.toLowerCase()] ?? fairburnMapConfig)
    : fairburnMapConfig;

export const LIVE_EVENTS_MAP_KEY: string = "LiveEventsMap";
export const USER_DISTRIBUTIONS_MAP_KEY: string = "UserDistributionsMap";
export const MERCHANT_MAP_KEY: string = "MerchantMap";
export const COMMUNITY_IMPACT_MAP_KEY: string = "CommunityImpactMap";

export const cityBoundary: FeatureCollection = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      id: 2881,
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-83.6985089996746, 43.39271100017127],
            [-83.6984879997582, 43.397054999971],
            [-83.69850799984967, 43.39816999976804],
            [-83.69851600024558, 43.399963000228176],
            [-83.69848000026059, 43.40714299986879],
            [-83.6984810000855, 43.41110600008929],
            [-83.6985100003978, 43.41150900006901],
            [-83.69852200009338, 43.41440799974766],
            [-83.69850299982679, 43.415218000067036],
            [-83.69853299996403, 43.41785000019688],
            [-83.6985020000019, 43.41855299983655],
            [-83.6984679996667, 43.4190160000883],
            [-83.69844799957522, 43.4191420000048],
            [-83.69844299955234, 43.41961599985885],
            [-83.69844900029844, 43.42022100012658],
            [-83.69844900029844, 43.42089800010372],
            [-83.6984669998418, 43.42139799989917],
            [-83.69848299973532, 43.42147200020185],
            [-83.69851600024558, 43.42154699998435],
            [-83.69853600033709, 43.42172299977022],
            [-83.69850799984967, 43.42493799978686],
            [-83.6985100003978, 43.4254090001096],
            [-83.69854399983468, 43.42795600014191],
            [-83.69854300000976, 43.42879099990507],
            [-83.69856399992617, 43.436011000270916],
            [-83.69859499988831, 43.44061100016394],
            [-83.69864299956889, 43.443145000093075],
            [-83.69864900031499, 43.44403999987611],
            [-83.69865199978972, 43.4443870000027],
            [-83.6986650002085, 43.44530300002211],
            [-83.69866600003343, 43.445337000106186],
            [-83.69866799968325, 43.44547599973318],
            [-83.69867100005628, 43.44563699975116],
            [-83.69868299975185, 43.446008999879545],
            [-83.69869000032286, 43.44694800015838],
            [-83.69869199997268, 43.44716199999724],
            [-83.6986939996225, 43.4474009998397],
            [-83.69869500034574, 43.447457000097415],
            [-83.6987000003686, 43.44786799967993],
            [-83.69870100019352, 43.44794000000488],
            [-83.6986939996225, 43.44841699999263],
            [-83.69869799982048, 43.44884099986733],
            [-83.69869899964539, 43.44899099999105],
            [-83.6987000003686, 43.449165999773946],
            [-83.69870200001844, 43.44928900024627],
            [-83.69870500039148, 43.44955300003374],
            [-83.69870200001844, 43.450413999751945],
            [-83.6987000003686, 43.450927000124004],
            [-83.69869899964539, 43.45114699993816],
            [-83.69869899964539, 43.45117000032607],
            [-83.69869799982048, 43.451425999941776],
            [-83.69871000041437, 43.452309999688374],
            [-83.69871100023926, 43.452356000223006],
            [-83.69871100023926, 43.452375999707336],
            [-83.69871299988908, 43.45254999976775],
            [-83.69871299988908, 43.452625000167835],
            [-83.698713999714, 43.4528449996745],
            [-83.698713999714, 43.45289000009748],
            [-83.698713999714, 43.45325100001828],
            [-83.69871299988908, 43.453645000026704],
            [-83.69871200006418, 43.45405199990215],
            [-83.69873200015564, 43.45650000014686],
            [-83.6987349996304, 43.45684100007918],
            [-83.6987349996304, 43.45685999974543],
            [-83.6987360003536, 43.457107000079624],
            [-83.69873200015564, 43.4572240002976],
            [-83.69873200015564, 43.45724900024793],
            [-83.69873999965327, 43.45818800013115],
            [-83.69873700017854, 43.45839199992762],
            [-83.69873100033075, 43.45975100029994],
            [-83.69872999960752, 43.45987499969944],
            [-83.69872999960752, 43.45998800012438],
            [-83.69872999960752, 43.460219000214764],
            [-83.69873700017854, 43.46049999990549],
            [-83.6987360003536, 43.46075700002695],
            [-83.69873399980548, 43.46136300004263],
            [-83.69874300002631, 43.46228700017595],
            [-83.69874499967614, 43.462813000139704],
            [-83.69874600039937, 43.46310199971013],
            [-83.69874600039937, 43.463185000251855],
            [-83.69874700022427, 43.463525000118985],
            [-83.69874700022427, 43.463555999850676],
            [-83.698749999699, 43.4641870001884],
            [-83.698749999699, 43.46426199984742],
            [-83.69874800004919, 43.46489900028529],
            [-83.698749999699, 43.465299000286976],
            [-83.69875100042223, 43.46553599987877],
            [-83.69875200024715, 43.46577399998901],
            [-83.69880999997346, 43.47685400001748],
            [-83.69881599982124, 43.47895699997085],
            [-83.70401000040354, 43.47895300026854],
            [-83.71847500009518, 43.47896500002653],
            [-83.71869000018035, 43.47896599995191],
            [-83.72098300024872, 43.47894500021131],
            [-83.72750799955318, 43.47890799968829],
            [-83.73165299964896, 43.47887899986153],
            [-83.73844099961748, 43.47881499994733],
            [-83.74338499995451, 43.47876800005886],
            [-83.74831599987274, 43.47873800023577],
            [-83.74999299999797, 43.478719000274886],
            [-83.75563299974577, 43.478656000121774],
            [-83.75867400000179, 43.47864899995585],
            [-83.76831800027837, 43.47862600024303],
            [-83.7683989995709, 43.47862600024303],
            [-83.76873400020497, 43.478622999798056],
            [-83.77806700013693, 43.47866899986904],
            [-83.77861500030802, 43.47867799989301],
            [-83.78803699992844, 43.4787509999654],
            [-83.79278299989876, 43.47880899972786],
            [-83.79387900024093, 43.47882300002182],
            [-83.79794700034383, 43.478877000007834],
            [-83.80036400026074, 43.478891000286076],
            [-83.8076760001109, 43.47895699997085],
            [-83.81270900013638, 43.47900099993796],
            [-83.81440800000291, 43.47901700003656],
            [-83.81599399989155, 43.47903400005522],
            [-83.81767799968947, 43.47905199999307],
            [-83.81762099978806, 43.486131000037126],
            [-83.81761999996314, 43.48620999971419],
            [-83.81762099978806, 43.48628999974392],
            [-83.81759499984878, 43.49312499979462],
            [-83.8171589998307, 43.49313200023831],
            [-83.81725400026525, 43.49649800003378],
            [-83.81733899975575, 43.499212000110546],
            [-83.81735800002231, 43.50002299992026],
            [-83.81752000040402, 43.50781700029525],
            [-83.81751700003099, 43.50797000031496],
            [-83.81728799970213, 43.51539199985798],
            [-83.81722800032597, 43.52234500027337],
            [-83.8182280004087, 43.522336000242625],
            [-83.82670000017512, 43.52221600013811],
            [-83.82680999977998, 43.522216999998825],
            [-83.83337099996777, 43.52222299981419],
            [-83.83339600008213, 43.52222500018676],
            [-83.8364149996985, 43.5222329997223],
            [-83.83662499976079, 43.522241999768454],
            [-83.84638200001528, 43.522331000297314],
            [-83.84663300008545, 43.52233200015612],
            [-83.8540649995862, 43.52236800027358],
            [-83.85687200038879, 43.52235500016124],
            [-83.85925400014563, 43.52235299979299],
            [-83.86682399973864, 43.52238899989792],
            [-83.8668630000967, 43.52238899989792],
            [-83.86915799981487, 43.52239200012285],
            [-83.86938399977069, 43.52239299998064],
            [-83.8701579998976, 43.52240299986057],
            [-83.87088199979577, 43.52241199988136],
            [-83.8709329998494, 43.522412999738826],
            [-83.87150799978467, 43.52242000004345],
            [-83.87208400044317, 43.52242699969591],
            [-83.87240400011031, 43.52241699981995],
            [-83.87750200043311, 43.52244399987201],
            [-83.87766200026668, 43.52244499972895],
            [-83.88265199973617, 43.52247900006629],
            [-83.88353700019114, 43.5224849998556],
            [-83.88555700044803, 43.52249799993993],
            [-83.88688999971836, 43.522519000170405],
            [-83.88746600037685, 43.522509000309704],
            [-83.88761600016467, 43.52251199987728],
            [-83.88772999996749, 43.52251299973308],
            [-83.88784299994539, 43.52251400024026],
            [-83.89049400021405, 43.52253200024735],
            [-83.89314600030762, 43.52254899974254],
            [-83.89605799979388, 43.52256800024551],
            [-83.89913300038505, 43.522577000241654],
            [-83.8992699997541, 43.52257800009643],
            [-83.89940700002145, 43.52257800009643],
            [-83.89969800027458, 43.52257899995115],
            [-83.90056299973978, 43.52258100031191],
            [-83.90281899999822, 43.52258799994569],
            [-83.905866000102, 43.52259799979329],
            [-83.90593999972184, 43.52259799979329],
            [-83.90621799955618, 43.52259900029906],
            [-83.91035799962908, 43.52261199970738],
            [-83.91185300017943, 43.52261599977532],
            [-83.91212699981581, 43.52261700028079],
            [-83.91241800006895, 43.522618000134855],
            [-83.91449699987709, 43.522623999910394],
            [-83.91529399957021, 43.52262600026966],
            [-83.91609100016163, 43.52262899983141],
            [-83.91674499973962, 43.52263299989818],
            [-83.91681500005981, 43.52263299989818],
            [-83.91741500010944, 43.52263699996471],
            [-83.91793800016616, 43.522640000177304],
            [-83.91846000039799, 43.522642999738316],
            [-83.92130800031013, 43.522658000146805],
            [-83.92287400010729, 43.5226660002763],
            [-83.9259449996022, 43.52268299973369],
            [-83.92663900026146, 43.52269300021692],
            [-83.92686299966914, 43.5226880003012],
            [-83.92775599962172, 43.52269300021692],
            [-83.92778599975894, 43.52269300021692],
            [-83.92780000000265, 43.52269300021692],
            [-83.93111099969707, 43.522537000176],
            [-83.93141100017104, 43.522609999999034],
            [-83.93147100044548, 43.52266200021168],
            [-83.93153099982163, 43.522712999875665],
            [-83.93161799986026, 43.52271200002316],
            [-83.93168499980742, 43.52271200002316],
            [-83.93317799980964, 43.52272199985022],
            [-83.93473699993409, 43.52273099982342],
            [-83.93715899987387, 43.522765999851195],
            [-83.93987799991459, 43.522804999914015],
            [-83.93992200029552, 43.52280599976497],
            [-83.9402019997797, 43.52281100032229],
            [-83.94223100025744, 43.522843999951675],
            [-83.94512000017745, 43.5228900002142],
            [-83.95050399983224, 43.52296300026142],
            [-83.95099400027699, 43.52297300004687],
            [-83.95551299956827, 43.523030999681644],
            [-83.96028299982804, 43.52311099978274],
            [-83.96738600033912, 43.523206000049925],
            [-83.96779100039507, 43.523211999766986],
            [-83.96915200015282, 43.5232300002172],
            [-83.97350800013578, 43.52328900009922],
            [-83.97375900020596, 43.52329200027939],
            [-83.97394400015389, 43.52329499980803],
            [-83.97402100014678, 43.52329600030223],
            [-83.9741719997595, 43.52329799998785],
            [-83.97436000008048, 43.52330100016756],
            [-83.974888999985, 43.52330699987513],
            [-83.97507399993292, 43.523309000211746],
            [-83.9769319998081, 43.523330000159916],
            [-83.97950500025897, 43.52335999998015],
            [-83.98457400026946, 43.52338400008615],
            [-83.99444699997659, 43.523318999939846],
            [-83.99469600039694, 43.52332500029699],
            [-83.99990500014954, 43.52347700024383],
            [-84.00011799968654, 43.52348299993389],
            [-84.00562199989022, 43.523608999801205],
            [-84.01432700018348, 43.52368799995083],
            [-84.0144200000699, 43.52369299978366],
            [-84.01675300032124, 43.52371500008542],
            [-84.01786800003167, 43.52372499974622],
            [-84.01853699967826, 43.523735000056725],
            [-84.021848000271, 43.523783999795505],
            [-84.02199700023392, 43.52378600011636],
            [-84.02635200039198, 43.52384400027226],
            [-84.02767200014183, 43.52386199988252],
            [-84.03438499976728, 43.52398199996979],
            [-84.05098699989169, 43.52406399977268],
            [-84.05097799967086, 43.52444200015553],
            [-84.05074699969218, 43.531998000075305],
            [-84.05072400012595, 43.53273799979335],
            [-84.05063100023955, 43.53777799992488],
            [-84.05062899969141, 43.53789599982513],
            [-84.05060799977502, 43.538448999911935],
            [-84.05059899955418, 43.53857100011374],
            [-84.05044200009367, 43.544866999902126],
            [-84.05042200000216, 43.545705000283604],
            [-84.05025299994777, 43.552647000230905],
            [-84.05025700014573, 43.552842000037415],
            [-84.0502699996662, 43.55292400031517],
            [-84.05020799974193, 43.55606299997497],
            [-84.05017900032792, 43.55819799994523],
            [-84.05016799955895, 43.55898800002563],
            [-84.05013999996987, 43.56007000023451],
            [-84.05007700022068, 43.56244899982309],
            [-84.05000000022778, 43.56732400012656],
            [-84.05071099970718, 43.56731000017825],
            [-84.05233699977877, 43.56732100018439],
            [-84.05498100037472, 43.5673449997175],
            [-84.0593509997031, 43.56738599976556],
            [-84.06580599958568, 43.56746400008162],
            [-84.0699259995671, 43.56751399984726],
            [-84.07219000022147, 43.56751899995173],
            [-84.08110499967869, 43.567551000089715],
            [-84.08966400038207, 43.56763400028699],
            [-84.0907029999245, 43.567645999992415],
            [-84.10955000043674, 43.568049000208916],
            [-84.10993799987594, 43.56804400014844],
            [-84.12125400025486, 43.56814100007575],
            [-84.12498699972369, 43.56817500003338],
            [-84.12941300002686, 43.56821600016743],
            [-84.12957000038571, 43.56821999981384],
            [-84.13468999955151, 43.56828399997888],
            [-84.1372730000481, 43.56832599978579],
            [-84.13881000043125, 43.56835099996694],
            [-84.13910900018199, 43.56835099996694],
            [-84.14092199985133, 43.56838199991671],
            [-84.14661000017803, 43.56846300013022],
            [-84.14933599989145, 43.56848999974325],
            [-84.15436399989406, 43.568600000162995],
            [-84.15487299970708, 43.56860399978395],
            [-84.1592300004133, 43.56868600009089],
            [-84.16812700032716, 43.568898999898344],
            [-84.168349000085, 43.56198999973325],
            [-84.1684110000093, 43.559954999780246],
            [-84.16843299975058, 43.559079000159805],
            [-84.16868200017095, 43.55141400009789],
            [-84.16869100039176, 43.551128999975575],
            [-84.16870100043752, 43.55070400029388],
            [-84.16871800015596, 43.55038099967727],
            [-84.16881799971507, 43.54783400012343],
            [-84.16904700004393, 43.539705999698555],
            [-84.16921299972529, 43.53600399992861],
            [-84.16938599997764, 43.53252400010932],
            [-84.16957599994845, 43.52596899973213],
            [-84.1695729995754, 43.52532099979199],
            [-84.16957900032149, 43.52523899974365],
            [-84.1696219999792, 43.52163000008561],
            [-84.16962500035224, 43.521426000114474],
            [-84.1696859995533, 43.51800599988777],
            [-84.16972400008645, 43.516629999700186],
            [-84.16976000007146, 43.51535200024043],
            [-84.16980199990425, 43.51386600031653],
            [-84.16986100035379, 43.510882000214465],
            [-84.17011300024888, 43.500542000276134],
            [-84.17012199957138, 43.50003999989208],
            [-84.17012599976934, 43.49982099969678],
            [-84.17022200002882, 43.49694599981319],
            [-84.17022200002882, 43.49641000014036],
            [-84.17040000030404, 43.490131000140885],
            [-84.17040199995387, 43.488682999942164],
            [-84.17057600003113, 43.48196899982558],
            [-84.1755999998358, 43.481944000320766],
            [-84.17608299970955, 43.481944000320766],
            [-84.1799659998645, 43.481925999940906],
            [-84.18063500040944, 43.48191699974893],
            [-84.1865689998851, 43.48188800006277],
            [-84.1890679998178, 43.48187499970448],
            [-84.18967999956298, 43.48187200007262],
            [-84.1906300003153, 43.48186600015674],
            [-84.20378299975472, 43.48179200005843],
            [-84.21030399975955, 43.481770000117386],
            [-84.21046799979106, 43.48176500007043],
            [-84.21559100022824, 43.48176000002306],
            [-84.22040499997061, 43.48174099970888],
            [-84.23024099986782, 43.48170799976647],
            [-84.24010199987939, 43.481671000283704],
            [-84.24989199974584, 43.48162800018693],
            [-84.252486999938, 43.481611000246296],
            [-84.2607100001824, 43.48153500006991],
            [-84.26956000024062, 43.48150000024815],
            [-84.26968499991409, 43.48149899971288],
            [-84.26976000025716, 43.48149899971288],
            [-84.26987999990774, 43.4814969999459],
            [-84.26994000018222, 43.4814969999459],
            [-84.28237200009649, 43.48144099992533],
            [-84.28400700038893, 43.481419999741306],
            [-84.28770899989561, 43.48141000024087],
            [-84.29082600031957, 43.481417999971704],
            [-84.29766799981645, 43.481423000047435],
            [-84.30074400023256, 43.481425999701536],
            [-84.31072599971964, 43.48143800027198],
            [-84.31678300011727, 43.48147200024577],
            [-84.32117000006238, 43.48145799991381],
            [-84.33047799987999, 43.481507999967114],
            [-84.33619100032104, 43.48151599968498],
            [-84.34063099996962, 43.481522000287505],
            [-84.34255699961686, 43.48153099988648],
            [-84.34399699991562, 43.48153699983564],
            [-84.3505079998747, 43.48154600008422],
            [-84.35553199967934, 43.48156100027823],
            [-84.3697770001613, 43.48157300017008],
            [-84.3697920002299, 43.48053799976063],
            [-84.36982700039, 43.47411900029697],
            [-84.36982999986476, 43.473935000289394],
            [-84.36983499988762, 43.47336499984198],
            [-84.36984599975827, 43.4714020002658],
            [-84.36984599975827, 43.471324000183024],
            [-84.36987599989551, 43.4660439997137],
            [-84.36989500016207, 43.462749999704755],
            [-84.36992500029929, 43.458710999764],
            [-84.36996200010923, 43.45142300010285],
            [-84.36997700017784, 43.4483330002677],
            [-84.36996200010923, 43.43717700001045],
            [-84.3699610002843, 43.43709500026422],
            [-84.36996899978192, 43.43385200026005],
            [-84.36994500039079, 43.42257700003765],
            [-84.36993600016994, 43.41942400026599],
            [-84.36992699994912, 43.41182200013165],
            [-84.36991299970542, 43.40809599994621],
            [-84.36990900040577, 43.40469100012433],
            [-84.3698680003979, 43.393602000157024],
            [-84.36984999995623, 43.38967299984981],
            [-84.36984999995623, 43.3896119998204],
            [-84.36984699958319, 43.38866000024599],
            [-84.36984099973539, 43.38787599992946],
            [-84.36982999986476, 43.386595000015284],
            [-84.36978899985687, 43.383225999743274],
            [-84.36978899985687, 43.383213999921594],
            [-84.3698049997504, 43.381207999826934],
            [-84.36980800012344, 43.37910100011955],
            [-84.36982700039, 43.377989999961294],
            [-84.36982999986476, 43.375429999924705],
            [-84.3698259996668, 43.37502999995058],
            [-84.36979499970464, 43.37229899973104],
            [-84.36977600033639, 43.36715400018726],
            [-84.36976200009269, 43.36461100004477],
            [-84.36974700002406, 43.36089000003861],
            [-84.36972000025989, 43.35446800011084],
            [-84.36972000025989, 43.3544400000907],
            [-84.36968500009979, 43.35008999985362],
            [-84.369679000252, 43.34624000019215],
            [-84.36964300026699, 43.33559799999204],
            [-84.36964300026699, 43.33174299991131],
            [-84.36961899997755, 43.328356000116884],
            [-84.3696159996045, 43.32326299997733],
            [-84.36959399986318, 43.32112900011736],
            [-84.3695660002741, 43.31719999985582],
            [-84.36956999957376, 43.317135000197226],
            [-84.36948000006039, 43.30728300013147],
            [-84.36949099993102, 43.30657999968853],
            [-84.36946099979382, 43.302342999772414],
            [-84.36941300011321, 43.29477100028469],
            [-84.36940800009036, 43.29209600029224],
            [-84.36937299993026, 43.289060999989125],
            [-84.36936100023469, 43.28888100032421],
            [-84.36936399970944, 43.287981999705416],
            [-84.36935600021182, 43.28768999992969],
            [-84.36927599984588, 43.28263300016884],
            [-84.36927599984588, 43.282518999818365],
            [-84.36925900012744, 43.277585999715164],
            [-84.3692070002489, 43.27284900018494],
            [-84.36904099966924, 43.26311500016206],
            [-84.36905999993581, 43.25814800003355],
            [-84.3689829999429, 43.252108000183625],
            [-84.36899200016374, 43.250436999715575],
            [-84.36898200011801, 43.248593999817274],
            [-84.36894000028522, 43.246383000172635],
            [-84.36891900036882, 43.24386699973822],
            [-84.36892900041455, 43.243365000267595],
            [-84.36882899995713, 43.234126999969845],
            [-84.36880700021581, 43.22919199967964],
            [-84.36878200010146, 43.227424000084845],
            [-84.36873699989563, 43.219554999904716],
            [-84.36872699984987, 43.21819999970539],
            [-84.36867599979627, 43.21457699969482],
            [-84.36863999981125, 43.21185300020859],
            [-84.36862599956756, 43.209101999771825],
            [-84.36863099959041, 43.208696000270635],
            [-84.36862100044299, 43.2083289998264],
            [-84.36861200022214, 43.205762999921795],
            [-84.36858999958254, 43.20503099989159],
            [-84.36854100007704, 43.20113200032493],
            [-84.36854000025214, 43.20077700006937],
            [-84.36850799956676, 43.19615499994132],
            [-84.36843300012201, 43.19049700014676],
            [-84.36841800005341, 43.189296000095176],
            [-84.36839899978682, 43.18667199970458],
            [-84.3683979999619, 43.18632799972698],
            [-84.36840299998478, 43.18583199969777],
            [-84.36837000037282, 43.182979999922445],
            [-84.36833199983967, 43.17947200010793],
            [-84.36832500016698, 43.17665099969513],
            [-84.36832099996901, 43.17654399978964],
            [-84.36832299961884, 43.176075000159415],
            [-84.3682990002277, 43.174463999940066],
            [-84.36829699967957, 43.17358400024484],
            [-84.36829699967957, 43.17337400020038],
            [-84.36829500002973, 43.173287999998735],
            [-84.36827999996112, 43.17252199983731],
            [-84.36826999991538, 43.17205899991342],
            [-84.36818600024979, 43.16337100020146],
            [-84.36818700007471, 43.16002999999151],
            [-84.36816799980814, 43.157806000080974],
            [-84.36816699998323, 43.15754400024794],
            [-84.36810900025691, 43.15443099967875],
            [-84.36806700042412, 43.14691300026057],
            [-84.36803599956366, 43.14296700000528],
            [-84.36791099989019, 43.13239200026441],
            [-84.3678909997987, 43.12845199980392],
            [-84.3646870002344, 43.128485999783656],
            [-84.3524799995527, 43.12855699975758],
            [-84.34479600015688, 43.128600999690825],
            [-84.3368080000891, 43.128680999726754],
            [-84.33500700011533, 43.128699000113784],
            [-84.33390800029841, 43.12870999991062],
            [-84.32624800029372, 43.12878599994296],
            [-84.32535899964078, 43.12877599996134],
            [-84.32036900017131, 43.12880999976103],
            [-84.32015800028412, 43.12880999976103],
            [-84.31994599967369, 43.12881100021762],
            [-84.31808199995072, 43.128815000077054],
            [-84.31669899955337, 43.12881800013533],
            [-84.31664300037518, 43.12881800013533],
            [-84.3160030001426, 43.128819999737054],
            [-84.3153210000772, 43.128821000193476],
            [-84.30591700000012, 43.12883999968423],
            [-84.30523099973676, 43.1288449999978],
            [-84.28916799956261, 43.12890900030412],
            [-84.28538099966713, 43.12892300011632],
            [-84.26730599963199, 43.12894600008188],
            [-84.26622100005878, 43.12892600016936],
            [-84.2564439997128, 43.12883299976903],
            [-84.25608300003778, 43.12883299976903],
            [-84.25158800013764, 43.128862999680955],
            [-84.2490640000906, 43.12886799999269],
            [-84.248023, 43.12885899982471],
            [-84.24661399966338, 43.128835999826435],
            [-84.24605600034486, 43.128829999711485],
            [-84.24356800028282, 43.128841999940846],
            [-84.23145600003568, 43.128799999783325],
            [-84.2295350004113, 43.128795999922914],
            [-84.22770900032316, 43.12876599997812],
            [-84.22689699966313, 43.12879400032041],
            [-84.22658600021681, 43.12878399968452],
            [-84.21936600042817, 43.12870500024163],
            [-84.21658200009011, 43.12867399979336],
            [-84.20998900011527, 43.12865699985807],
            [-84.20745199964942, 43.12867099972801],
            [-84.20692899959269, 43.12867399979336],
            [-84.20604099966297, 43.12868999992093],
            [-84.20034200036395, 43.128695000246765],
            [-84.19563200037865, 43.128693999788275],
            [-84.19433699984484, 43.12869200018245],
            [-84.19282399975116, 43.12866099972758],
            [-84.19178199983565, 43.128646999855405],
            [-84.19056500001797, 43.12865699985807],
            [-84.18852899986754, 43.128680999726754],
            [-84.18774600041813, 43.128690999723915],
            [-84.18609199985913, 43.12870999991062],
            [-84.18164299998973, 43.12868900011799],
            [-84.1758810000432, 43.12867399979336],
            [-84.16844299979635, 43.128630999716584],
            [-84.16804399958818, 43.12863299998003],
            [-84.16482599978018, 43.128712999974105],
            [-84.16388000012412, 43.12873500021639],
            [-84.16303300020229, 43.12875500019136],
            [-84.16293399956977, 43.12875699979514],
            [-84.1628220003151, 43.12875999985626],
            [-84.1627090003372, 43.12876399971903],
            [-84.16259200016133, 43.12876800023711],
            [-84.16251799964319, 43.12876999984046],
            [-84.16244300019841, 43.12877200009936],
            [-84.16232600002256, 43.12877599996134],
            [-84.16081999960156, 43.12880599990127],
            [-84.15446900037436, 43.12897100029114],
            [-84.15363999999587, 43.12899599983456],
            [-84.15277600035562, 43.1290240000716],
            [-84.14853900019831, 43.129126000311544],
            [-84.14838400038762, 43.12913399998891],
            [-84.14092299967623, 43.12933799993181],
            [-84.13378200042862, 43.12950099996278],
            [-84.13278800019371, 43.12953100020268],
            [-84.1304990003233, 43.129569999836995],
            [-84.12609099956347, 43.12967100003508],
            [-84.1245089998728, 43.12971100002199],
            [-84.12337099969784, 43.12973800014588],
            [-84.12167900040232, 43.12977700030376],
            [-84.10972799981366, 43.130082000243824],
            [-84.10926800040443, 43.1300940002276],
            [-84.10888500008977, 43.13010600020897],
            [-84.10849699975225, 43.13011599997315],
            [-84.1073510000797, 43.1301459999114],
            [-84.08959999990965, 43.13059299987087],
            [-84.0894550001447, 43.13059200009898],
            [-84.08862800031434, 43.13060000024025],
            [-84.077359999616, 43.13092599969724],
            [-84.06994999985655, 43.13115800013482],
            [-84.06755100038127, 43.131227000106456],
            [-84.050387999667, 43.13170899994149],
            [-84.04669299983301, 43.13174800015375],
            [-84.04606199982123, 43.13175499973534],
            [-84.045671000009, 43.13175900005784],
            [-84.0430890002356, 43.13178699968555],
            [-84.04269500005032, 43.131791000005954],
            [-84.04189099978619, 43.131799999742505],
            [-84.04074299956548, 43.13181200004475],
            [-84.03917500011852, 43.13182899975867],
            [-84.03839099994589, 43.131836999738134],
            [-84.03736099972593, 43.13184800028176],
            [-84.03524400028299, 43.13187000005199],
            [-84.03342999989042, 43.131888999906764],
            [-84.03282399999301, 43.13189499972167],
            [-84.03239899984557, 43.13189999978549],
            [-84.02748899984373, 43.131914000224256],
            [-84.01827599956236, 43.13200999977507],
            [-84.01754900018943, 43.13201799973082],
            [-84.01512899989947, 43.132014000080844],
            [-84.0128490002499, 43.132048999795394],
            [-84.01127199968377, 43.13205500025015],
            [-84.01034399957108, 43.13205899989744],
            [-84.00774199970625, 43.13206899999785],
            [-84.0071619997481, 43.132074000047446],
            [-83.99998899981512, 43.13214199989475],
            [-83.98873400043385, 43.132257999883905],
            [-83.98806499988895, 43.13227200024072],
            [-83.980859000344, 43.132336000238915],
            [-83.97911299972348, 43.13235100032102],
            [-83.97883400006424, 43.13235400020587],
            [-83.96841599966075, 43.132451999860166],
            [-83.96101000009926, 43.13253200010368],
            [-83.95512299958094, 43.132587999949656],
            [-83.95061799963504, 43.13259799996358],
            [-83.94961000005473, 43.13260299996991],
            [-83.94876700033088, 43.13259299995682],
            [-83.94535399963087, 43.132672000278056],
            [-83.94423700027063, 43.13268000014721],
            [-83.94399100022332, 43.13267899975391],
            [-83.94302799995054, 43.13267500014716],
            [-83.94196500011866, 43.13267099988462],
            [-83.94162199998696, 43.132670000146696],
            [-83.94137099991681, 43.13266899975323],
            [-83.94108399986162, 43.13266800001528],
            [-83.94094699959429, 43.13266700027736],
            [-83.94089499971574, 43.13266700027736],
            [-83.94069200022446, 43.13266700027736],
            [-83.94067899980568, 43.13266899975323],
            [-83.94057400022369, 43.132670000146696],
            [-83.94034599971974, 43.132665999883834],
            [-83.94016900016774, 43.13266399975229],
            [-83.9401170002892, 43.13266300001425],
            [-83.94003199990038, 43.13266200027624],
            [-83.93984799977737, 43.1326609998826],
            [-83.93948100025457, 43.13266000014456],
            [-83.93930600035237, 43.13265899975092],
            [-83.9389699998934, 43.13265800001281],
            [-83.9382929998509, 43.13266700027736],
            [-83.93800999999368, 43.13267099988462],
            [-83.93554200002312, 43.13270599987871],
            [-83.9290789997446, 43.132782000190225],
            [-83.92917500000408, 43.13570900003989],
            [-83.92925399964679, 43.137697999832255],
            [-83.92942500024932, 43.141981999832446],
            [-83.92962699991568, 43.14720799969493],
            [-83.92975800033526, 43.15066099978442],
            [-83.92985899971929, 43.15324500012164],
            [-83.9298949997043, 43.15427600023188],
            [-83.92990099955209, 43.154446000238586],
            [-83.93017400026186, 43.161670999777144],
            [-83.93046600033992, 43.17064700005257],
            [-83.93053099973892, 43.172740999796865],
            [-83.93058299961747, 43.174418999891046],
            [-83.93063500039432, 43.176096999736494],
            [-83.93096299955906, 43.18681199967356],
            [-83.93105299997076, 43.19053299987841],
            [-83.93107499971205, 43.19114600001801],
            [-83.93107800008512, 43.191286000204435],
            [-83.93108700030594, 43.19173499990361],
            [-83.93118400039032, 43.194674999692474],
            [-83.93130099966785, 43.19821500000546],
            [-83.9314930001868, 43.20424299997103],
            [-83.93150999990524, 43.20476900030635],
            [-83.93151499992811, 43.20488800020995],
            [-83.9317180003177, 43.21045200029315],
            [-83.9320709995968, 43.22037700028008],
            [-83.93186999975535, 43.22037700028008],
            [-83.93178699991468, 43.22037799989232],
            [-83.9309430003659, 43.22038400018395],
            [-83.93044000040065, 43.2203869996749],
            [-83.92625400029699, 43.220416999813345],
            [-83.92398200014502, 43.22045899985142],
            [-83.92135099996784, 43.22047300029405],
            [-83.919073999793, 43.220500999860555],
            [-83.91632999963792, 43.2205320002072],
            [-83.91490299975796, 43.22054499971442],
            [-83.91388099993394, 43.22057400016606],
            [-83.91302300014145, 43.22057799991126],
            [-83.91289199972188, 43.22059499980734],
            [-83.91271900036784, 43.220601999686174],
            [-83.90880799972548, 43.2206129999617],
            [-83.90617999992135, 43.220609999827225],
            [-83.90355299994214, 43.22060799995572],
            [-83.90227199965203, 43.220622999972406],
            [-83.89371000037224, 43.22066499986857],
            [-83.89100800004995, 43.22068400026412],
            [-83.88261699957606, 43.220676000132734],
            [-83.8825499996289, 43.220676000132734],
            [-83.88240400003905, 43.220676000132734],
            [-83.88229899955874, 43.22067199973937],
            [-83.88212500037979, 43.22066400026103],
            [-83.88205400023467, 43.220659999866896],
            [-83.88190000024889, 43.22065400025707],
            [-83.8801550003516, 43.22066699973822],
            [-83.87790300029111, 43.220691000132696],
            [-83.87522899955793, 43.2207199998603],
            [-83.8747339999886, 43.220724999857104],
            [-83.87379500000526, 43.220734000243056],
            [-83.87356099965353, 43.22077199967596],
            [-83.87161900011274, 43.22081299986441],
            [-83.86767200038368, 43.220860999874326],
            [-83.85911400040354, 43.2209549999207],
            [-83.85415199962483, 43.22100700019057],
            [-83.85359199975818, 43.22101400002206],
            [-83.8372459997268, 43.22108400025686],
            [-83.83434299956308, 43.22110400012217],
            [-83.83383600029819, 43.22109600004588],
            [-83.83083400040024, 43.22112299972623],
            [-83.82068799998332, 43.22119200023701],
            [-83.81449400021664, 43.22121000021512],
            [-83.81099400037634, 43.221228999786156],
            [-83.81011700031729, 43.22123000003904],
            [-83.80962900042064, 43.22123100029193],
            [-83.80948999960515, 43.22123300014301],
            [-83.80770200005017, 43.22125199970692],
            [-83.80500399992586, 43.221267000219804],
            [-83.80471699987066, 43.221269000069654],
            [-83.80436000039361, 43.221269000069654],
            [-83.79435200006895, 43.22125799991249],
            [-83.79402099963283, 43.22125700031467],
            [-83.79383499986001, 43.22125700031467],
            [-83.78824000031804, 43.221248000005936],
            [-83.78450399957785, 43.221251000109014],
            [-83.77786600029548, 43.22126100001507],
            [-83.776860000365, 43.22124900025852],
            [-83.77467299970351, 43.22128500017572],
            [-83.77446799966411, 43.22128200007431],
            [-83.76993199975608, 43.221300000025856],
            [-83.76979000036417, 43.22130100027758],
            [-83.76932699968359, 43.22129399982442],
            [-83.76916600002511, 43.22129199997534],
            [-83.76902600028302, 43.22129399982442],
            [-83.76886499972622, 43.22129599967344],
            [-83.76866200023495, 43.22129599967344],
            [-83.76824200011038, 43.22129699992519],
            [-83.76459599978189, 43.22131100017544],
            [-83.76343900023866, 43.22132200032304],
            [-83.75711300022752, 43.2213350003164],
            [-83.75148900037323, 43.22133700016408],
            [-83.7476360003555, 43.22134200011028],
            [-83.74522600011124, 43.22135300025229],
            [-83.73787999992591, 43.22134299970669],
            [-83.73505499957999, 43.22133299981409],
            [-83.73398300042558, 43.22132499976786],
            [-83.73315800024504, 43.22131900022351],
            [-83.72748400016205, 43.22135200000142],
            [-83.72387100034385, 43.22136000004411],
            [-83.72353400005994, 43.22135899979334],
            [-83.72015800006818, 43.22135099975053],
            [-83.71528499987627, 43.22137100018286],
            [-83.7151390002864, 43.2213719997788],
            [-83.71152399992005, 43.221379000223024],
            [-83.71001000000145, 43.22138700026216],
            [-83.70449900012508, 43.22138799985784],
            [-83.70265799996832, 43.22139200020422],
            [-83.70099799956152, 43.22140200008715],
            [-83.69958800029832, 43.221405999778035],
            [-83.69847900043567, 43.22140200008715],
            [-83.6980659999838, 43.22140099983712],
            [-83.69651600008018, 43.22139599989576],
            [-83.69562099957946, 43.22142199984814],
            [-83.69561399990677, 43.222217000089266],
            [-83.69562800015048, 43.226088000023054],
            [-83.69564800024195, 43.22772199992108],
            [-83.69573399955736, 43.23225900028193],
            [-83.69573299973246, 43.232654999986465],
            [-83.69577200009051, 43.23590300025594],
            [-83.69577499956524, 43.23633900005427],
            [-83.69579700020488, 43.23743300024791],
            [-83.69581800012126, 43.23991000019047],
            [-83.69585400010628, 43.24304099982057],
            [-83.6958549999312, 43.243128999676195],
            [-83.69585699958103, 43.243589000005414],
            [-83.69585699958103, 43.24410800013008],
            [-83.69585400010628, 43.2467680002202],
            [-83.69584400006055, 43.24704599984124],
            [-83.69582700034209, 43.24778100011154],
            [-83.69582200031923, 43.24998900005085],
            [-83.69582099959601, 43.25028400014215],
            [-83.69581800012126, 43.2504049997553],
            [-83.69581599957313, 43.250568999782786],
            [-83.69581599957313, 43.250867000290334],
            [-83.69582200031923, 43.25206200006633],
            [-83.69578200013625, 43.254142999849336],
            [-83.69579600037996, 43.256811000025266],
            [-83.69578100031134, 43.25748199989985],
            [-83.69577000044069, 43.2620460000163],
            [-83.69575399964886, 43.2644250003167],
            [-83.69575799984682, 43.265565999772235],
            [-83.69570900034132, 43.27171100012664],
            [-83.69567300035631, 43.27347400025908],
            [-83.69562099957946, 43.27923399976953],
            [-83.69560800005898, 43.280281000275],
            [-83.69558100029481, 43.28464000019518],
            [-83.69561200025694, 43.28646400027748],
            [-83.69561200025694, 43.287565999762144],
            [-83.69555700000537, 43.29174499978962],
            [-83.69549099988312, 43.29375800020843],
            [-83.69547900018756, 43.294925999910284],
            [-83.69545999992098, 43.29535800012676],
            [-83.69543300015681, 43.296883000145094],
            [-83.69542700030902, 43.29721999995802],
            [-83.6954259995858, 43.29729000024561],
            [-83.69542200028614, 43.2976130000523],
            [-83.69537399970726, 43.30131699974144],
            [-83.69535299979087, 43.304669000011195],
            [-83.69533500024751, 43.30682699986958],
            [-83.69530400028536, 43.307501999974505],
            [-83.6952850000188, 43.309212000117654],
            [-83.69529900026251, 43.310794000305265],
            [-83.69529699971437, 43.3119310000033],
            [-83.69528400019388, 43.314210999841684],
            [-83.69520499965284, 43.320797999720725],
            [-83.6952080000259, 43.321043999711755],
            [-83.6952299997672, 43.321178000074156],
            [-83.69528599984372, 43.32134300015834],
            [-83.69526099972936, 43.32585099981892],
            [-83.69525800025461, 43.32604799969742],
            [-83.69559200016546, 43.32607400006825],
            [-83.69577399974033, 43.32609800009899],
            [-83.69594199996983, 43.326131999799664],
            [-83.69617700014646, 43.32615999980791],
            [-83.6963069998428, 43.32619599979957],
            [-83.69654399966927, 43.32624600007932],
            [-83.69675700010461, 43.32627999969711],
            [-83.69691000026549, 43.32632599991853],
            [-83.69738100044367, 43.32639299986618],
            [-83.69759300015578, 43.326404999819744],
            [-83.69807000018176, 43.32642200024],
            [-83.698389000024, 43.32644799979724],
            [-83.69838800019907, 43.32653800028989],
            [-83.69838800019907, 43.326627999995694],
            [-83.69837899997825, 43.328455999693176],
            [-83.6983329999475, 43.3305529998658],
            [-83.69833100029767, 43.331999000035346],
            [-83.6982850002669, 43.335895000016365],
            [-83.69824300043412, 43.3399760001434],
            [-83.69825299958156, 43.34332600014961],
            [-83.69821800031976, 43.347541000255724],
            [-83.69819099965727, 43.34981400017691],
            [-83.6981999998781, 43.35021100023921],
            [-83.69820200042624, 43.35071699995061],
            [-83.69817099956578, 43.354802999980166],
            [-83.69817099956578, 43.35803699975647],
            [-83.69813399975585, 43.36206199970674],
            [-83.69813899977872, 43.364728000140694],
            [-83.69814600034974, 43.36535999973245],
            [-83.69820499990098, 43.370863000298925],
            [-83.69821199957366, 43.37289800021036],
            [-83.6982490002819, 43.37425799995156],
            [-83.69825599995458, 43.37608299986916],
            [-83.6982989996123, 43.37753400029184],
            [-83.69832799992462, 43.3791590001235],
            [-83.69832999957444, 43.37926600016525],
            [-83.69833999962017, 43.37961199984379],
            [-83.69834299999324, 43.37972800012434],
            [-83.69834299999324, 43.3798190002454],
            [-83.69834399981814, 43.37997800006451],
            [-83.69836399990963, 43.38152999986759],
            [-83.6984810000855, 43.39136299997751],
            [-83.6985089996746, 43.39271100017127],
          ],
        ],
      },
      properties: {
        MTFCC: "G4020",
        OID: "2759057662897",
        GEOID: "26145",
        STATE: "26",
        COUNTY: "145",
        COUNTYNS: "01623015",
        BASENAME: "Saginaw",
        NAME: "Saginaw County",
        LSADC: "06",
        FUNCSTAT: "A",
        COUNTYCC: "H1",
        AREALAND: "2074080707",
        AREAWATER: "39260627",
        OBJECTID: 2881,
        CENTLAT: "+43.3349886",
        CENTLON: "-084.0532897",
        INTPTLAT: "+43.3282667",
        INTPTLON: "-084.0554100",
      },
    },
  ],
};
